export default __webpack_public_path__ + "static/media/ema-john.7b3c72ac.PNG";